import styled from 'styled-components'

export const Widget = styled.section`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: rgba(185, 221, 226, 0.2);
  margin-bottom: 20px;
  flex-wrap: nowrap;
  height: 50px;
  width: 100%;
`

export const Icon = styled.img`
  width: 12px;
  height: 12px;
  flex: 0 0 auto;
  vertical-align: middle;
`

export const Text = styled.p`
  margin: 0;
  font-size: 12px;
  color: #103b40;
  white-space: nowrap;

  strong {
    font-weight: 700;
  }

  span[aria-hidden='true'] {
    opacity: 0.4;
    padding: 0 6px;
  }
`

export const LearnMoreLink = styled.button`
  border: 0;
  background: transparent;
  text-decoration: underline;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  color: #0b3a3f;
  white-space: nowrap;
  margin-left: auto;

  &:hover {
    opacity: 0.85;
  }
  &:focus-visible {
    outline: 2px solid #0b3a3f;
    outline-offset: 2px;
    border-radius: 4px;
  }
`
